module.exports = __webpack_public_path__ + "cania-programas.f65262289e1af3648095.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconos/fonts/cania-programas.eot?s2o10a
// module id = 354
// module chunks = 2